<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Download File</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="download file" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>File Name</label>
                <input type="text" placeholder="e.g. results.csv" v-model="fileName" />
            </div>
            <div class="form-group">
                <label>Sheet Name</label>
                <select v-model="sheetName">
                    <option value="">Select Sheet</option>
                    <option v-for="sheet in worksheets" :key="sheet" :value="sheet">
                        {{ sheet }}
                    </option>
                </select>
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createDownloadFileWorkflowItem } from '../utils/workflowUtils';
import { useWorksheetSelection } from '../composables/useWorksheetSelection';

// Use composable for worksheet selection
const { worksheets } = useWorksheetSelection();

const actionName = ref('');
const fileName = ref('');
const sheetName = ref('');

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createDownloadFileWorkflowItem(
        actionName.value,
        fileName.value,
        sheetName.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
